import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "ApiClient";
import { ApiURL } from "utils/Actions";
import { API_RESPONSE_STATUS } from "utils/Constants";
import { showErrorModal } from "utils/hooks/handleNotification";
import { StudentQualType } from "utils/Types";
import { common } from "utils/Wording";

type Year12QualSliceType = {
  data: StudentQualType;
  isLoading: boolean;
  isLoadingError: boolean;
};

const Year12QualInit: Year12QualSliceType = {
  data: {} as Year12QualSliceType["data"],
  isLoading: true,
  isLoadingError: false
};

export const fetchYear12Qual = createAsyncThunk("/year12Qual", async (refNum: number) => {
  if (!refNum) {
    throw new Error(common.loadingError);
  }

  try {
    const res = await api.get(`${ApiURL.year12Qual}/${String(refNum)}`);
    if (res?.data?.status === API_RESPONSE_STATUS.ERROR) {
      throw new Error(common.loadingError);
    }
    return res?.data?.data ? res.data.data : [];
  } catch (error: any) {
    showErrorModal({
      title: common.failAsync,
      errors: error.response?.data?.errors ? error.response.data.errors : [error.message]
    });
    return Year12QualInit.data;
  }
});

export const Year12QualSlice = createSlice({
  name: "year12-qual",
  initialState: Year12QualInit,
  reducers: {
    setYear12Qual: (state, action) => {
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        isLoadingError: false
      };
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchYear12Qual.pending, state => {
      state.isLoading = true;
      state.isLoadingError = false;
    });
    builder.addCase(fetchYear12Qual.fulfilled, (state, action) => {
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        isLoadingError: false
      };
    }),
      builder.addCase(fetchYear12Qual.rejected, () => {
        return {
          data: Year12QualInit.data,
          isLoading: false,
          isLoadingError: true
        };
      });
  }
});

export const { setYear12Qual } = Year12QualSlice.actions;

export default Year12QualSlice.reducer;
